import React, { Component } from "react";
import { Card, Button, Row, Col, Form } from 'react-bootstrap';
import Swal from "sweetalert2";
import { DISPLAY_WALL_SUCCESS_SAVE, SUCCESS_TEXT } from "../../messageText";
import Select from 'react-select';
import { connect } from "react-redux";
import { addApp, getLeaderboard, updateApp } from '../../../../../../../actions/sceneActions'
import moment from "moment";
import LeaderIframe from "./leaderBorad/leaderIframe";
import { NavigationHeader } from "../../../_metronic/layout/components/navigationheader/NavigationHeader";
import { getInitialRoute, stripTrailingSlash } from "../../../../../../../utils";

class LeaderBoard extends Component {
    state = {
        leaderBoardOptions: [
            { value: 1, label: 'Most Popular Influencers' },
            { value: 2, label: 'Most Active Creators' }
        ],
        rowsOption: [
            { value: 3, label: 'Top 3' },
            { value: 5, label: 'Top 5' },
        ],
        themeOptions: [
            { value: 0, label: 'Light' },
            { value: 1, label: 'Dark' }
        ],
        leader: 2,
        numberOfRows: 3,
        theme: 0,
        dateTo: moment(),
        dateFrom: moment().subtract(29, 'days'),
        updateApi: false,
        topUsers: [],
        apiStatus: false,
        isSaved: false,
        isEdited: false,
        isRequest: false,
        buttonDis: false,
        loader: false,
        stateChanged: false,
    }

    componentWillMount() {
        const { scenes } = this.props;
        const { app_data } = scenes.updateSceneData;
        if (app_data) {
            const { leader, numberOfRows, dateTo, dateFrom, theme } = app_data;
            this.setState({
                leader, numberOfRows, dateTo, dateFrom, theme,
                updateApi: true
            }, () => this.getLeaders());
        }
        else this.getLeaders()
    }

    componentDidMount() {

        const { scenes, location } = this.props;
        const { app_data } = scenes.updateSceneData;
        if (app_data && location.pathname.includes('update')) {
            const { leader, numberOfRows, dateTo, dateFrom, theme } = app_data;
            this.setState({
                leader, numberOfRows, dateTo, dateFrom, theme,
                updateApi: true
            }, () => this.getLeaders());
        }
    }

    onSave = (event) => {
        const { param } = this.props;
        const { numberOfRows, theme, dateFrom, leader,
            dateTo, isRequest } = this.state
        // getLeaderboard({
        //     leader: leader,
        //     rows: numberOfRows,
        //     startDate: `${moment(dateFrom).format('YYYY-MM-DD')}%2000:00:00`,
        //     endDate:`${moment(dateTo).format('YYYY-MM-DD')}%2000:00:00`
        // })

        // console.log(this.state, moment(dateFrom).format('YYYY-MM-DD'))
        if (!isRequest) {
            this.setState({ isRequest: true, buttonDis: true, loader: true })
            this.state.updateApi ?
                this.props.updateApp(
                    param.contentMixId,
                    this.props.scenes.updateSceneData.id,
                    { leader, numberOfRows, dateTo, dateFrom, theme },
                    10,
                    this.onSaveCallBack
                ) :
                this.props.addApp(
                    param.contentMixId,
                    param.positionID,
                    { leader, numberOfRows, dateTo, dateFrom, theme },
                    "Leader Board",
                    10,
                    this.onSaveCallBack
                );
        }
    };

    onSaveCallBack = () => {
        const { params } = this.props.match;
        Swal.fire({
            title: SUCCESS_TEXT,
            text: DISPLAY_WALL_SUCCESS_SAVE,
            type: "success",
            icon: 'success',
            showConfirmButton: false,
            timer: 3000
        }
        ).then((result) => {
            this.props.history(`/studio/${params.wallId}`)
        })
        this.setState({ isRequest: false, buttonDis: false, loader: false })

    }


    onBack = (event) => {
        const { params } = this.props.match;
        const { pathname } = this.props.location;
        const { isSaved, isEdited, } = this.state

        if (!this.state.stateChanged) {
            this.props.history(stripTrailingSlash(pathname, params))
            return;
        }

        if (!isSaved && isEdited) {
            Swal.fire({
                title: "Are you sure?",
                text: "Your changes have not been saved. Do you want to save before you leave the page?",
                showCancelButton: true,
                confirmButtonText: "Save",
                cancelButtonText: "Discard Changes",
                reverseButtons: true
            }).then((result) => {
                if (result.value) {
                    const { param } = this.props;
                    const { numberOfRows, theme, dateFrom, leader,
                        dateTo } = this.state
                    this.state.updateApi ?
                        this.props.updateApp(
                            param.contentMixId,
                            this.props.scenes.updateSceneData.id,
                            { leader, numberOfRows, dateTo, dateFrom, theme },
                            10,
                            () => {
                                this.setState({ isSaved: true })

                                Swal.fire(
                                    SUCCESS_TEXT,
                                    DISPLAY_WALL_SUCCESS_SAVE,
                                    "success"
                                )
                            }
                        ) :
                        this.props.addApp(
                            param.contentMixId,
                            param.positionID,
                            { leader, numberOfRows, dateTo, dateFrom, theme },
                            "Leader Board",
                            10,
                            () => {
                                this.setState({ isSaved: true })

                                Swal.fire(
                                    SUCCESS_TEXT,
                                    DISPLAY_WALL_SUCCESS_SAVE,
                                    "success"
                                )
                                this.props.history(`/studio/${params.wallId}`)
                            }
                        );

                } else if (result.dismiss === "cancel") {
                    this.props.history(stripTrailingSlash(pathname, params))
                }
            });
        }
        else this.props.history(`/studio/${params.wallId}`)

    }

    selectLeader = (value) => {
        this.setState({ leader: value, topUsers: [], apiStatus: false, isEdited: true }, () => this.getLeaders())

    }

    selectRows = (e) => {
        this.setState({ numberOfRows: e.value, topUsers: [], apiStatus: false, isEdited: true }, () => this.getLeaders())

    }

    getLeaders = () => {
        const { numberOfRows, dateFrom, leader, dateTo } = this.state
        const { scenes } = this.props;

        getLeaderboard({
            leader: leader,
            rows: numberOfRows,
            startDate: `${moment(dateFrom).startOf('day').unix()}`,
            // startDate: `${moment(dateFrom).format('YYYY-MM-DD')}%2000:00:00`,
            endDate: `${moment(dateTo).endOf('day').unix()}`,
            feedLists: scenes.feedList
            // endDate:`${moment(dateTo).format('YYYY-MM-DD')}%2000:00:00`
        }).then(res => {
            this.setState({ topUsers: res.data.responseData.data, apiStatus: res.data.status, stateChanged: true })
        })
    }
    startDateChange = (e) => {
        this.setState({ dateFrom: new Date(e.target.value), topUsers: [], apiStatus: false, isEdited: true }, () => this.getLeaders())

    }
    endDateChange = (e) => {
        this.setState({ dateTo: new Date(e.target.value), topUsers: [], apiStatus: false, isEdited: true }, () => this.getLeaders())

    }

    render() {
        const { leaderBoardOptions, numberOfRows, theme, dateFrom, rowsOption, leader, themeOptions, apiStatus,
            dateTo, topUsers, buttonDis, loader } = this.state

        const { match } = this.props;
        const { pathname } = this.props.location;

        return (<>
            <NavigationHeader
                name={'Leader Board'}
                backToNavigation={`${pathname ? stripTrailingSlash(pathname, match) : ''}`}
            />
            <div className="container-fluid subheader_content">
                <Card className="select_wall mb-3 rounded-0 border-0">
                    <Card.Body className="p-0">
                        <Row>
                            <Col lg={4} className="border-right-lg">
                                <Card className="border-0 rounded-0">
                                    <Card.Body className="p-4 card_height">
                                        <Form>
                                            {/* <Form.Group controlId="formBasicEmail">
                                            <Form.Label>Language*</Form.Label>
                                            <Select
                                                value={language.find(option => option.value === languageValue)}
                                                onChange={this.onUpdateLanguage}
                                                options={language}
                                            />
                                        </Form.Group> */}
                                            <Form.Group className="form-group" controlId="formBasicEmail">
                                                <Form.Label>Select Leader Board option</Form.Label>
                                                <Select
                                                    // value={temperatureUnit.find(option => option.value === temperatureUnitText)}
                                                    onChange={(e) => this.selectLeader(e.value)}
                                                    // options={temperatureUnit}
                                                    defaultValue={leaderBoardOptions[0]}
                                                    value={leaderBoardOptions.find(opt => opt.value == leader)}
                                                    options={leaderBoardOptions}
                                                />
                                            </Form.Group>
                                            <Form.Group className="form-group" controlId="formBasicEmail">
                                                <Form.Label>Show no. of rows</Form.Label>
                                                <Select
                                                    defaultValue={rowsOption[0]}
                                                    onChange={(e) => this.selectRows(e)}
                                                    value={rowsOption.find(opt => opt.value == numberOfRows)}
                                                    options={rowsOption}
                                                />
                                            </Form.Group>
                                            <Form.Group className="form-group" controlId="date">
                                                <Form.Label>Select Leader Board option</Form.Label>
                                                <Row>
                                                    <Col xl>
                                                        <Form.Group controlId="dateFrom">
                                                            <Form.Label>From</Form.Label>
                                                            <Form.Control
                                                                id="date-from"
                                                                type="date"
                                                                value={moment(dateFrom).format("YYYY-MM-DD")}
                                                                onChange={(e) => this.startDateChange(e)}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col xl>

                                                        <Form.Group controlId="dateTo">
                                                            <Form.Label>To</Form.Label>
                                                            <Form.Control
                                                                id="date-to"
                                                                type="date"
                                                                value={moment(new Date(dateTo)).format("YYYY-MM-DD")}
                                                                onChange={(e) => this.endDateChange(e)}
                                                            // onChange={this.changedate}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                            </Form.Group>
                                            <Form.Group className="form-group" controlId="formBasicEmail">
                                                <Form.Label>Theme</Form.Label>

                                                {/* <Select
                                                value={defaultTheme.find(option => option.value === defaultThemeValue)}
                                                onChange={this.onUpdateDefaltTheme}
                                                options={defaultTheme}
                                                isSearchable={false}
                                            /> */}
                                                <Select
                                                    value={themeOptions.find(option => option.value === theme)}
                                                    onChange={(e) => this.setState({ theme: e.value, isEdited: true })}
                                                    // options={temperatureUnit}                                                defaultValue={{value: 10 , label: 'Top 10'}}
                                                    defaultValue={themeOptions[0]}

                                                    options={themeOptions}
                                                />
                                            </Form.Group>

                                        </Form>
                                    </Card.Body>
                                    <Card.Footer className="bg-transparent d-flex justify-content-end border-0 p-4">
                                        <button className="btn btn-outline-dark me-3 btn-min-w"
                                            onClick={this.onBack}><span className="position-relative">Back</span></button>
                                        <Button variant="primary" disabled={buttonDis} className={`btn btn-primary btn-min-w ${loader ? `spinner spinner-white spinner-right disabled` : null}`} id="Studio_Leaderboard_App_Users"
                                            onClick={this.onSave}
                                        >Save</Button>
                                    </Card.Footer>
                                </Card>
                            </Col>
                            <Col lg={8} className="d-flex align-items-center justify-content-center">
                                <Card className="border-0 card w-100">
                                    <Card.Body className="border-0">
                                        <div className="wall_view">
                                            <div className="wall_view_wrapper">
                                                {/* {topUsers ? <LeaderBoardFrame rows={numberOfRows} theme={theme} topUsers={topUsers}/> : null} */}
                                                {topUsers ? <LeaderIframe rows={numberOfRows} theme={theme} topUsers={topUsers} apiStatus={apiStatus} leader={leader} /> : null}
                                                {/* <WeatherIframeComp weatherData={this.state.weatherData} currentData={this.state.currentData} selectedOption={this.state.selectedOption} defaultThemeValue={this.state.defaultThemeValue} /> */}
                                            </div>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>

                    </Card.Body>
                </Card>
            </div>
        </>)
    }
}

const mapStateToProps = (state) => {
    return {
        studioWall: state.studio.studioWall,
        scenes: state.scene,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        addApp: (contentMixId, position, appContent, appName, appId, callBack) =>
            dispatch(
                addApp(contentMixId, position, appContent, appName, appId, callBack)
            ),
        updateApp: (contentMixId, sceneContentId, appContent, appId, callBack) =>
            dispatch(
                updateApp(contentMixId, sceneContentId, appContent, appId, callBack)
            ),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(LeaderBoard);